module.exports = __webpack_public_path__ + "img/1.945a1697.png";